// import { List, Avatar } from 'antd';
import React from "react";
import {
    Table, Input, Space, message,
    Form, Select, Row, Col, DatePicker, ConfigProvider
} from 'antd';
import moment from 'moment';

import Highlighter from 'react-highlight-words';
import Button from "antd-button-color";
import { SearchOutlined, FileExcelOutlined } from '@ant-design/icons';

import { getRegion, searchTerritory, searchSaleAndStore, reportWeb, reportExcel } from "./service";

import locale from 'antd/lib/locale/th_TH';
// const data = [
//     {
//         title: 'รายงานการเข้าพบลูกค้า Check-in/Check-out',
//         description: 'รายงานการเข้าพบลูกค้า Check-in/Check-out'
//     },
//     {
//         title: 'รายงานการ Track พิกัดของพนักงานขาย',
//         description: 'รายงานการ Track พิกัดของพนักงานขาย'
//     }
// ];
// const report = () => {
//     return (
//         <List
//             style={{ textAlign: 'left', fontSize: '25px' }}
//             itemLayout="horizontal"
//             dataSource={data}
//             size="large"
//             renderItem={item => (
//                 <List.Item>
//                     <List.Item.Meta
//                         avatar={<SolutionOutlined />}
//                         title={<a href="#">{item.title}</a>}
//                         // title={<a>{item.title}</a>}
//                         description={item.description}
//                     />
//                 </List.Item>
//             )}
//         />
//     )
// }
const { RangePicker } = DatePicker;
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 26 },
        sm: { span: 24 },
        md: { span: 18 },
        lg: { span: 16 },
    },
};
const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0
        },
        sm: {
            span: 16,
            offset: 8
        }
    }
};
const tailFormItemLayout2 = {
    wrapperCol: {
        xs: {
            span: 0,
            offset: 0
        },
        sm: {
            span: 0,
            offset: 0
        }
    }
}
const { Option } = Select;
const dateFormat = 'YYYY-MM-DD';
const infoNodata = () => {
    message.info('ไม่พบข้อมูล!');
};
class report extends React.Component {
    formRef = React.createRef();
    state = {
        searchText: '',
        searchedColumn: '',
        sortedInfo: null,
        data: null,
        visible: false,
        visibleEdit: false,
        current: 1,
        pageSize: 10,
        pagination: {
            current: 1,
            pageSize: 10,
        },
        region: null,
        rID: '',
        regionSelected: null,
        territory: null,
        tID: '',
        territorySelected: '',
        store: null,
        storeID: '',
        storeSelected: null,
        sale: null,
        saleID: '',
        saleSelected: null,
        report: [],
        dateRange: null,
        startDate: moment().format(dateFormat),
        endDate: moment().format(dateFormat)
    };

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        getRegion().then(res => {
            if (res && res.status === 200) {
                this.setState({
                    region: res.data
                })
            }
        })
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({ closeDropdown: false });
                            this.setState({
                                searchText: selectedKeys[0],
                                searchedColumn: dataIndex,
                            });
                        }}
                    >
                        Filter
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select(), 100);
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    getColumnSearchProps2 = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({ closeDropdown: false });
                            this.setState({
                                searchText: selectedKeys[0],
                                searchedColumn: dataIndex,
                            });
                        }}
                    >
                        Filter
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select(), 100);
            }
        },
    });

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    };

    handleChange = (pagination, filters, sorter) => {
        // console.log('Various parameters', pagination, filters, sorter);
        this.setState({
            filteredInfo: filters,
            sortedInfo: sorter,
            current: pagination.current,
            pageSize: pagination.pageSize,
            pagination,
            // pagination: {
            //     current: pagination.current,
            //     pageSize: pagination.pageSize,
            // },
        });
    };

    clearFilters = () => {
        this.setState({ filteredInfo: null });
    };

    clearAll = () => {
        this.setState({
            filteredInfo: null,
            sortedInfo: null,
        });
    };
    onGenderChange = (value) => {
        switch (value) {
            case 'male':
                this.formRef.current.setFieldsValue({
                    note: 'Hi, man!',
                });
                return;

            case 'female':
                this.formRef.current.setFieldsValue({
                    note: 'Hi, lady!',
                });
                return;

            case 'other':
                this.formRef.current.setFieldsValue({
                    note: 'Hi there!',
                });
        }
    };
    onFinish = (values) => {
        // console.log(values);
        var dataReport = {
            "rID": this.state.rID,
            "saleAreaCd": this.state.tID,
            "storeID": this.state.storeID,
            "saleID": this.state.saleID,
            "startDate": this.state.startDate,
            "endDate": this.state.endDate,
        }
        reportWeb(dataReport).then(res => {
            // console.log("reportWebres===", res)
            if (res && res.status === 200) {
                if (res.data.info.length == 0) {
                    infoNodata()
                }
                this.setState({
                    report: res.data.info,
                    pagination: {
                        current: 1,
                        pageSize: 10,
                    },
                })
            }
        })

    };
    dd = () => {
        console.log('state ', this.state, moment().format(dateFormat),);

    }

    selectRegion = (e, name) => {
        let rID = e.toString()
        this.setState({
            rID: rID,
            regionSelected: name.region,
            territory: null,
            tID: '',
            territorySelected: '',
            store: null,
            storeID: '',
            storeSelected: null,
            sale: null,
            saleID: '',
            saleSelected: null,
        })
        this.getTerritory(rID);
    }
    getTerritory(rID) {
        searchTerritory(rID).then(res => {
            // console.log("resgetTerritory===", res)
            if (res && res.status === 200) {
                this.setState({
                    territory: res.data
                })
            }
        })
    }

    selectTerritory = (e, name) => {
        // console.log('e', e);
        // console.log('name', name);
        // console.log('rID', this.state.rID);

        let tID = e.toString()
        let rID = this.state.rID
        this.setState({
            tID: tID,
            territorySelected: name.territory,
            store: null,
            storeID: '',
            storeSelected: null,
            sale: null,
            saleID: '',
            saleSelected: null,
        })
        this.getStoreAndSale(tID, rID);
    }
    getStoreAndSale(tID, rID) {
            // console.log("researchSaleAndStores===tID, rID", tID, rID)
        searchSaleAndStore(tID, rID).then(res => {
            if (res && res.status === 200) {
                this.setState({
                    store: res.data.store,
                    sale: res.data.sale_staff
                })
            }
        })
    }

    selectStore = (e, name) => {
        let storeID = e.toString()
        this.setState({
            storeID: storeID,
        })
    }
    selectSale = (e, name) => {
        let saleID = e.toString()
        this.setState({
            saleID: saleID,
        })
    }

    optionRegion = () => {
        var region = this.state.region
        // console.log('region', region);

        return (
            <Select
                showSearch
                style={{ width: '100%' }}
                placeholder="กรุณาเลือกพื้นที่"
                optionFilterProp="children"
                filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                filterSort={(optionA, optionB) =>
                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                }
                onChange={this.selectRegion}
            >
                {
                    region.map((data, index) => {
                        return (
                            <Option key={index} value={data.rID} region={data.region} >{data.region}</Option>
                        );
                    })
                }
            </Select>
        )
    }
    optionTerritory = () => {
        var territory = this.state.territory

        if (territory !== null) {
            if (territory.length > 0) {
                return (
                    <Select
                        showSearch
                        style={{ width: '100%' }}
                        placeholder="เลือกเขตการขาย"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                        onChange={this.selectTerritory}
                    >
                        <Option value="" territory="" rid="">ทั้งหมด</Option>
                        {
                            territory.map((data, index) => {
                                return (
                                    <Option key={index} value={data.tID} territory={data.territory} rid={data.rID}>{data.territory}</Option>
                                );
                            })
                        }
                    </Select>
                )
            } else {
                return (
                    <Select
                        showSearch
                        style={{ width: '100%' }}
                        placeholder="เลือกเขตการขาย"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                        onChange={this.selectTerritory}
                    >
                    </Select>
                )
            }
        } else {
            return (
                <Select
                    showSearch
                    style={{ width: '100%' }}
                    placeholder="เลือกเขตการขาย"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    filterSort={(optionA, optionB) =>
                        optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                    }
                    onChange={this.selectTerritory}
                >
                </Select>
            )
        }
    }
    optionStore = () => {
        var store = this.state.store

        if (store !== null) {
            if (store.length > 0) {
                return (
                    <Select
                        showSearch
                        style={{ width: '100%' }}
                        placeholder="เลือกร้านค้า"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                        onChange={this.selectStore}
                    >
                        <Option value="" storecd="" store_name="">ทั้งหมด</Option>
                        {
                            store.map((data, index) => {
                                return (
                                    <Option key={index} value={data.id} storecd={data.storeCd} store_name={data.store_name}>{data.store_name}</Option>
                                );
                            })
                        }
                    </Select>
                )
            } else {
                return (
                    <Select
                        showSearch
                        style={{ width: '100%' }}
                        placeholder="เลือกร้านค้า"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                    >
                    </Select>
                )
            }
        } else {
            return (
                <Select
                    showSearch
                    style={{ width: '100%' }}
                    placeholder="เลือกร้านค้า"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    filterSort={(optionA, optionB) =>
                        optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                    }
                >
                </Select>
            )
        }
    }
    optionSale = () => {
        var sale = this.state.sale
        // console.log('พนักงาน', sale)
        if (sale !== null) {
            if (sale.length > 0) {
                return (
                    <Select
                        showSearch
                        style={{ width: '100%' }}
                        placeholder="เลือกพนักงาน"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                        onChange={this.selectSale}
                    >
                        <Option value='' firstname_th='' fullname='' lastname_th='' saleid=''>ทั้งหมด</Option>
                        {
                            sale.map((data, index) => {
                                return (
                                    <Option key={index} value={data.saleID} firstname_th={data.firstName_th} fullname={data.fullname} lastname_th={data.lastName_th} saleid={data.saleID}>{data.fullname}</Option>
                                );
                            })
                        }
                    </Select>
                )
            } else {
                return (
                    <Select
                        showSearch
                        style={{ width: '100%' }}
                        placeholder="เลือกพนักงาน"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                    >
                    </Select>
                )
            }
        } else {
            return (
                <Select
                    showSearch
                    style={{ width: '100%' }}
                    placeholder="เลือกพนักงาน"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    filterSort={(optionA, optionB) =>
                        optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                    }
                >
                </Select>
            )
        }
    }

    dateChange = (date, dateString) => {
        // console.log('( date, dateString)', date, dateString)
        this.setState({
            dateRange: dateString,
            startDate: dateString[0],
            endDate: dateString[1]
        })
    }
    inputDateRange = () => {
        return (
            <ConfigProvider locale={locale}>
                <RangePicker
                    // defaultValue={[moment('2015/01/01', dateFormat), moment('2015/01/01', dateFormat)]}
                    format={dateFormat}
                    onChange={this.dateChange}
                />
            </ConfigProvider>
        )
    }
    exportExcel = () => {
        var dataExport = {
            "rID": this.state.rID,
            "saleAreaCd": this.state.tID,
            "storeID": this.state.storeID,
            "saleID": this.state.saleID,
            "startDate": this.state.startDate,
            "endDate": this.state.endDate,
            "regionSelected": this.state.regionSelected,
            "territorySelected": this.state.territorySelected
        }
        // console.log('storeID', dataExport)
        reportExcel(dataExport)
        // .then(res => {
        //     console.log("reportExcelres===", res)
        //     if (res && res.status === 200) {

        //     }
        // })
    }
    render() {

        let { sortedInfo } = this.state;
        sortedInfo = sortedInfo || {};
        const { pageSize, current, pagination } = this.state;
        const columns = [
            {
                title: 'ลำดับ',
                align: 'center',
                width: '4%',
                key: 'id',
                dataIndex: 'no',
                render: (text, record, index) => {
                    return (((current - 1) * pageSize) + index + 1)
                },
            },
            {
                title: 'พื้นที่',
                dataIndex: 'region',
                key: 'region',
                width: '4%',
                ...this.getColumnSearchProps('region'),
            },
            {
                title: 'เขตการขาย',
                dataIndex: 'saleAreaCd',
                key: 'saleAreaCd',
                width: '8%',
                ...this.getColumnSearchProps('saleAreaCd'),
            },
            {
                title: 'ชื่อพนักงานขาย',
                dataIndex: 'fullname',
                key: 'fullname',
                width: '11%',
                ...this.getColumnSearchProps('fullname'),
            },
            {
                title: 'จังหวัด',
                dataIndex: 'province',
                key: 'province',
                width: '8%',
                ...this.getColumnSearchProps('province'),
            },
            {
                title: 'ชื่อร้านค้า',
                dataIndex: 'storeName',
                key: 'storeName',
                width: '13%',
                ...this.getColumnSearchProps('storeName'),
            },
            {
                title: 'วันที่เข้าพบ',
                dataIndex: 'date',
                key: 'date',
                width: '8%',
                ...this.getColumnSearchProps('date'),
            },
            {
                title: 'เวลาเข้าพบ',
                dataIndex: 'startTime',
                key: 'startTime',
                width: '8%',
                ...this.getColumnSearchProps('startTime'),
            },
            {
                title: 'เวลาสิ้นสุด',
                dataIndex: 'endTime',
                key: 'endTime',
                width: '8%',
                ...this.getColumnSearchProps('endTime'),
            },
            {
                title: 'ระยะเวลา',
                dataIndex: 'cal_time',
                key: 'cal_time',
                width: '7%',
                ...this.getColumnSearchProps('cal_time'),
            },
            {
                title: 'latitude ร้านค้า',
                dataIndex: 'store_lat',
                key: 'store_lat',
                width: '10%',
                ...this.getColumnSearchProps('store_lat'),
            },
            {
                title: 'longitude ร้านค้า',
                dataIndex: 'store_lon',
                key: 'store_lon',
                width: '10%',
                ...this.getColumnSearchProps('store_lon'),
            },

            {
                title: 'latitude พนักงาน',
                dataIndex: 'latitude',
                key: 'latitude',
                width: '10%',
                ...this.getColumnSearchProps('latitude'),
            },
            {
                title: 'longitude พนักงาน',
                dataIndex: 'longitude',
                key: 'longitude',
                width: '10%',
                ...this.getColumnSearchProps('longitude'),
            },
            {
                title: 'ตำบล',
                dataIndex: 'tumbon_checkin',
                key: 'tumbon_checkin',
                width: '10%',
                ...this.getColumnSearchProps('tumbon_checkin'),
            },
            {
                title: 'อำเภอ',
                dataIndex: 'amphur_checkin',
                key: 'amphur_checkin',
                width: '10%',
                ...this.getColumnSearchProps('amphur_checkin'),
            },
            {
                title: 'จังหวัด',
                dataIndex: 'province_checkin',
                key: 'province_checkin',
                width: '10%',
                ...this.getColumnSearchProps('province_checkin'),
            },

            {
                title: 'ระยะทาง (km)',
                dataIndex: 'distance',
                key: 'distance',
                width: '10%',
                ...this.getColumnSearchProps('distance'),
            },
            {
                title: 'กรุ๊ปแบรนด์',
                dataIndex: 'groupBrand',
                key: 'groupBrand',
                width: '16%',
                ...this.getColumnSearchProps('groupBrand'),
            },
            {
                title: 'รหัสร้านค้า ขณะเข้าพบ',
                dataIndex: 'checkin_custID',
                key: 'checkin_custID',
                width: '13%',
                ...this.getColumnSearchProps('checkin_custID'),
            },
            {
                title: 'Cust. ID',
                dataIndex: 'loxtrade_custID',
                key: 'loxtrade_custID',
                width: '13%',
                ...this.getColumnSearchProps('loxtrade_custID'),
            },
            {
                title: 'ชื่อร้านค้า Master',
                dataIndex: 'loxtrade_custName',
                key: 'loxtrade_custName',
                width: '13%',
                ...this.getColumnSearchProps('loxtrade_custName'),
            },
            {
                title: 'เขตการขาย Master',
                dataIndex: 'loxtrade_custArea',
                key: 'loxtrade_custArea',
                width: '13%',
                ...this.getColumnSearchProps('loxtrade_custArea'),
            },
        ];

        return (
            <>
                <Space style={{ marginBottom: 16 }}>
                    <h2 onClick={this.dd}>รายงานตรวจสอบเส้นทางการเดินทางของพนักงานขาย</h2>
                </Space>
                <div style={{ width: '85%', margin: 'auto' }} >
                    <Form
                        {...formItemLayout}
                        ref={this.formRef}
                        name="search"
                        onFinish={this.onFinish}
                        initialValues={{
                            region: this.state.region,
                            // dateRange: this.state.dateRange
                            // dateRange: [moment('2015/01/01', dateFormat), moment('2015/01/01', dateFormat)],
                            dateRange: [moment(this.state.startDate, dateFormat), moment(this.state.endDate, dateFormat)]

                        }}
                        scrollToFirstError
                    >
                        <Row>
                            <Col span={12}>
                                <Form.Item
                                    style={{ marginBottom: '10px' }}
                                    shouldUpdate
                                    name="dateRange"
                                    label="ช่วงเวลา"
                                    rules={[
                                        {
                                            required: true,
                                        },
                                    ]}
                                >
                                    {/* {this.inputDateRange} */}
                                    {/* <ConfigProvider locale={locale}> */}
                                    <RangePicker
                                        format={dateFormat}
                                        onChange={this.dateChange}
                                    />
                                    {/* </ConfigProvider> */}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    style={{ marginBottom: '10px' }}
                                    name="region"
                                    shouldUpdate
                                    label="พื้นที่"
                                    rules={[
                                        {
                                            required: true,
                                        },
                                    ]}
                                >
                                    {/* {this.state.region ? this.optionRegion : <Select
                                        placeholder="กรุณาเลือกพื้นที่"
                                        allowClear
                                    ></Select>} */}
                                    <Select
                                        showSearch
                                        style={{ width: '100%' }}
                                        placeholder="กรุณาเลือกพื้นที่"
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        filterSort={(optionA, optionB) =>
                                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                        }
                                        onChange={this.selectRegion}
                                    >
                                        {this.state.region &&
                                            <>
                                                {
                                                    this.state.region.map((data, index) => {
                                                        return (
                                                            <Option key={index} value={data.rID} region={data.region} >{data.region}</Option>
                                                        );
                                                    })
                                                }
                                            </>
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row>
                            <Col span={12}>
                                <Form.Item
                                    style={{ marginBottom: '10px' }}
                                    shouldUpdate
                                    label="เขตการขาย"
                                >
                                    {this.state.territory ? this.optionTerritory : <Select
                                        placeholder="เลือกเขตการขาย"
                                        allowClear
                                    >
                                    </Select>}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    style={{ marginBottom: '10px' }}
                                    shouldUpdate
                                    label="ชื่อร้านค้า"
                                >
                                    {this.state.store ? this.optionStore : <Select
                                        placeholder="เลือกร้านค้า"
                                        allowClear
                                    >
                                    </Select>}
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row>
                            <Col span={12}>
                                <Form.Item
                                    style={{ marginBottom: '10px' }}
                                    shouldUpdate
                                    label="พนักงาน"
                                >
                                    {this.state.sale ? this.optionSale : <Select
                                        placeholder="เลือกพนักงาน"
                                        allowClear
                                    >
                                    </Select>}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item style={{ marginBottom: '10px', paddingRight: '35px' }} {...tailFormItemLayout2}>
                                    <Space direction="vertical" style={{ float: 'right' }}>
                                        <Space>
                                            <Button type="primary" htmlType="submit" icon={<SearchOutlined />}
                                            // style={{ marginLeft: '20px' }}
                                            >
                                                Search
                                            </Button>

                                            <Button type="success" icon={<FileExcelOutlined />}
                                                // style={{ float: 'right' }}
                                                onClick={this.exportExcel}
                                                disabled={this.state.report.length > 0 ? false : true}
                                            >
                                                Export
                                            </Button>
                                        </Space>
                                    </Space>
                                </Form.Item>
                            </Col>
                        </Row>

                    </Form>
                </div >

                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' : 'table-row-dark'}
                    columns={columns}
                    dataSource={this.state.report}
                    pagination={pagination}
                    onChange={this.handleChange}
                    size="small"
                    scroll={{ x: 1400, y: '100%' }}
                    rowKey={(record) => record.storeName + record.date + record.startTime}
                    // rowKey='id'
                    bordered
                />
            </>
        )
    }
}

export default report;
